/**
 * Prefix for static assets when the app is served from a subpath (beta: /react-app/).
 * CRA sets PUBLIC_URL from .env.production at build time.
 */
export function withPublicUrl(path: string): string {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path;
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  if (!path.startsWith('/')) {
    return base ? `${base}/${path}` : `/${path}`;
  }
  return base ? `${base}${path}` : path;
}
